import React, { memo, useCallback } from 'react';
import { DynamicListFilter, FilterProps } from '@dfl/mui-admin-layout';
import { useSearchParams } from 'react-router-dom';

interface CountryAddressFilterProps extends FilterProps {
  stateKey?: string;
  cityKey?: string;
  justUseFor?: string;
}

const CountryAddressFilter = ({ filter, value, title, stateKey, cityKey, justUseFor }: CountryAddressFilterProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const onHandleChange = useCallback(
    (e: any) => {
      // Create a new URLSearchParams object based on current ones
      const newSearchParams = new URLSearchParams(searchParams.toString());

      // If there is a state selected, we remove it using the provided key
      if (stateKey && searchParams.get(stateKey)) {
        newSearchParams.delete(stateKey);
      }

      // If there is a city selected, we remove it using the provided key
      if (cityKey && searchParams.get(cityKey)) {
        newSearchParams.delete(cityKey);
      }

      // Update the country parameter
      if (e?.[0]) {
        newSearchParams.set(filter.key, e[0]);
      } else {
        newSearchParams.delete(filter.key);
      }

      // Apply the changes
      setSearchParams(newSearchParams);
    },
    [filter.key, searchParams, setSearchParams, stateKey, cityKey],
  );

  if (justUseFor) return null;

  return <DynamicListFilter filter={filter} value={value} title={title} onChange={onHandleChange} />;
};

export default memo(CountryAddressFilter);
